import { Typography, Box, useMediaQuery } from "@mui/material";
import { useTheme } from '@mui/material/styles';

// Component for Variables content
const RequestDocumentation = () => {
    const theme = useTheme();
    const isMediumScreen = useMediaQuery(theme.breakpoints.down('md'));
    return (
        <Box style={{
            display: 'flex', flexDirection: 'column', gap: '16px', flex: 1, overflowY: 'auto',
            p: 3
        }}>

            <Typography
                variant="body1"
                style={{ width: isMediumScreen ? '100%' : '60%' }}
            >
                <strong>Request-Level Documentation</strong>
                <br />
                <br />
                <p>
                    HawkClient makes it easy to document individual requests using <strong>Markdown</strong>. Each request has a dedicated <strong>Docs</strong> tab where you can describe the purpose, expected input/output, and any additional notes for the request.
                </p>
                <p>
                    This is useful for maintaining clarity when working on large APIs or collaborating with team members, ensuring every request is self-explanatory and well-documented.
                </p>
            </Typography>

            <img
                src="/docs/RequestDoc.png"
                alt="validations"
                style={{
                    width: isMediumScreen ? '100%' : '60%',
                    // maxWidth: '800px',
                    height: 'auto',
                    display: 'block',
                    objectFit: 'contain',
                    marginTop: '16px',
                }}
            />

            <Typography
                variant="body1"
                style={{ width: isMediumScreen ? '100%' : '60%' }}
            >
                <p>
                    To edit the documentation, click on the <strong>Edit Mode</strong> button as shown in the screenshot below. This opens a Markdown editor where you can update the request's description in real time.
                </p>
            </Typography>

            <img
                src="/docs/RequestDocEdit.png"
                alt="validations"
                style={{
                    width: isMediumScreen ? '100%' : '60%',
                    // maxWidth: '800px',
                    height: 'auto',
                    display: 'block',
                    objectFit: 'contain',
                    marginTop: '16px',
                }}
            />
        </Box>
    )
};

export default RequestDocumentation;